import { CommonModule } from '@angular/common';
import { Component, EventEmitter, input, Input, OnInit } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { NavigationExtras,Router } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CustomProfileService } from 'src/app/core/services/custom-profile.service';
import { ToastService } from 'src/app/core/services/toaster.service';
import { TranslationService,I18nModule} from '@spartacus/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { CustomLandingModule } from '../../custom-landing.module';
import { FileUploader, FileUploadModule } from 'ng2-file-upload';
import { CommonconfirmpopupComponent } from 'src/app/modules/commonconfirmpopup/commonconfirmpopup.component';


@Component({
    selector: 'app-shipment-vms-ebl-bl',
    imports: [CommonModule, ReactiveFormsModule, SharedModule, I18nModule, CustomLandingModule, FileUploadModule],
    templateUrl: './shipment-vms-ebl-bl.component.html',
    styleUrl: './shipment-vms-ebl-bl.component.scss'
})
export class ShipmentVmsEblBlComponent implements OnInit{
  @Input() shipData: any;
  @Input() modalToOpen:any;
  @Input() flag:any;

  blQuantity = new FormControl('');
  ebl_confirmation = new FormControl();
  selected: boolean;
  isHidden: boolean;
  enableLoader: boolean;
  fileArray: any[]=[];
  base64: any;
  uploadErr = false;
  data:any;
  constructor(public ActiveModal: NgbActiveModal, public customprofile: CustomProfileService,
    public toastrService: ToastService,public router:Router,private translation: TranslationService, private modalService:NgbModal
  ) { }
  ngOnInit(): void {
    console.log(this.shipData, 'blpop');
    if(this.shipData.eblConfirmation === true){
      this.ebl_confirmation.setValue('yes');
    }else{
      this.ebl_confirmation.setValue('no');
    }
  }
  closeModal() {
    this.ActiveModal.close('close');
  }
  updateEBL(val: any) {
    this.ebl_confirmation.setValue(val);
  }
  SaveEBL() {
    let SaveObject = new Object({
      'eblConfirmation': this.ebl_confirmation.getRawValue().toLowerCase()=='yes'?true:false,
      'nominationNumber': this.shipData.nominationNumber,
      'nominationKey': this.shipData.nominationKey,
      'nominationItemNumber': this.shipData.nominationItemNumber,
    })
    let toastshown = false
    this.customprofile.saveShipmentDetails(SaveObject).subscribe((response: any) => {
      if (response) {
        this.translation.translate('shipment.savedusccess').subscribe(res=>{   
          if(!toastshown){
            this.toastrService.show(res);
            toastshown = true
          }
        })
      }
      else {
        this.translation.translate('shipment.emptyerrormessage').subscribe(res=>{   
          if(!toastshown){
            this.toastrService.show(res);
            toastshown = true
          }
        })
      }
      this.ActiveModal.close('saved');
    }, err => {
      this.translation.translate('shipment.erroroccuredmessage').subscribe(res=>{   
        if(!toastshown){
          this.toastrService.show(res);
          toastshown = true
        }
      })
      this.ActiveModal.close('saved');
    })
   
  }
  // saveBLQuantity(){
  //   console.log(this.blQuantity);
  //   let SaveObject = new Object({
  //     'blQuantity': this.blQuantity.value,
  //     'nominationNumber': this.shipData.nominationNumber,
  //     'nominationKey': this.shipData.nominationKey,
  //     'nominationItemNumber': this.shipData.nominationItemNumber,
  //   })
  //   this.customprofile.saveShipmentDetails(SaveObject).subscribe((response: any) => {
  //     if (response) {
  //       const navigationExtras: NavigationExtras = {state: { nominationItemNumber: this.shipData.nominationItemNumber,nominationKey: this.shipData.nominationKey,},skipLocationChange:true};
  //       this.router.navigateByUrl('/').then(() => {
  //         this.router.navigate(['/inventory/shipmentdetails/'+ this.shipData.nominationNumber],navigationExtras)
  //       });
  //       console.log(response)
  //     }
  //     else {
  //       this.toastrService.show('Response not returned from commerce, please contact support team');
  //     }
  //   }, err => {
  //     this.toastrService.show('Error while saving the data, please contact support team');
  //   })
  //   this.ActiveModal.close();
  // }

  batchCompleted(){
    let saveobject={files:this.fileArray}
    console.log(this.fileArray);
   let toastshown=false
    this.customprofile.saveBatchCompleted(this.shipData.code,'BATCHCOMPLETED', saveobject).subscribe((resp)=>{
      if(resp){
        this.translation.translate('shipment.savedusccess').subscribe(res=>{   
          if(!toastshown){
            this.toastrService.show(res);
            toastshown = true
          }
        })       
        this.ActiveModal.close('success');
      
      // this.router.navigateByUrl('/',{ skipLocationChange: true }).then(() => {
       
      //   this.router.navigate(['batches/dvl-tracking-list/' ],{queryParams:{tab:'COMPLETED'},skipLocationChange:true})
      // });
    }
    else{
      
      this.translation.translate('shipment.emptyerrormessage').subscribe(res=>{  
        if(!toastshown) {
          this.toastrService.show(res);
          toastshown =true
        }
      })
    }
  }, err => {
      // this.toastrService.show('Error while saving the data, please contact support team');
      this.translation.translate('shipment.erroroccuredmessage').subscribe(res=>{   
        if(!toastshown) {
          this.toastrService.show(res);
          toastshown =true
        }
      })
    })
  }

  closeBatchModal(){
    this.ActiveModal.close();
    //const navigationExtras: NavigationExtras = {state:  { baseProductCode: this.shipData.baseProductCode}};
      this.router.navigateByUrl('/',{ skipLocationChange: true }).then(() => {
        this.router.navigate(['batches/dvl-tracking-details/' + this.shipData.batchId],{queryParams:{baseProductCode: this.shipData.baseProductCode}});
        //this.router.navigate(['/batches/dvl-tracking-details/'+this.shipData.batchId],navigationExtras)
      });
  }

  screeningCompleted(){
    let saveobject={files:this.fileArray}
    console.log(this.fileArray);
    let toastshown = false;
    // if(this.fileArray.length === 0){
    //   this.uploadErr = true;
    // }else{
      // this.uploadErr = false;
      this.customprofile.saveBatchScreeningStatus(this.shipData.code,'SCREENINGCOMPLETED',saveobject).subscribe((resp)=>{
        if(resp.message=='Screening status updated successfully.'){
        this.translation.translate('shipment.savedusccess').subscribe(res=>{   
          if(!toastshown){
            this.toastrService.show(res);
            toastshown = true
          }
        })
        this.ActiveModal.close('success');
        }else{
          this.translation.translate('shipment.emptyerrormessage').subscribe(res=>{   
          if(!toastshown){
            this.toastrService.show(res);
            toastshown = true
          }
        })        }
       
      }, err => {
      this.translation.translate('shipment.erroroccuredmessage').subscribe(res=>{   
        if(!toastshown) {
          this.toastrService.show(res);
          toastshown =true
        }
      })      })
    // }
    
  }

  onDragOver(event) {
    event.preventDefault();
  }

  onDropSuccess(event) {
    event.preventDefault();
  
    //this.onFileChange(event.dataTransfer.files);
  }
  removeWarning(){
    this.uploadErr = false;
  } 
  public uploader: FileUploader = new FileUploader({
    url: ``,
    disableMultipart: false,
    autoUpload: true,
    method: 'post',
    itemAlias: 'attachment',
    allowedFileType: ['xls', 'xlsx','pdf','jpeg','png'],
    maxFileSize:10485760,
  });

  public onFileSelected(event: EventEmitter<File[]>) {
    
    this.enableLoader = true;
    const file: File = event[0];
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {

      this.base64 = reader.result
      const words = this.base64.split(',')[1]
      const filedata = {
        fileInBase64: words,
        mime: file.type,
        name: file.name,
        size: file.size.toString()
      }
    if((filedata.mime == 'application/pdf' || filedata.mime == 'image/jpeg' || filedata.mime == 'image/png' ||
       filedata.mime == 'application/vnd.ms-excel' || filedata.mime == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') && file.size < 10485760){
      this.fileArray.push(filedata);
      
    }
    else if(filedata.mime != 'application/jpeg' && filedata.mime != 'image/pdf' && filedata.mime != 'image/png' && filedata.mime != 'application/vnd.ms-excel' && filedata.mime != 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'){
      this.toastrService.show('Only PDF,JPEG and xlsx file formats are allowed');
    }
    else if(file.size > 10485760){
      this.toastrService.show('File size exceeds 10MB.');
    }
      this.enableLoader = false;

    }
  }

  hoverFileShow(param): void {
    this.selected = true;
    const hover = document.getElementById('remove' + param)
    if(hover) {hover.style.display = 'block'}
  }

  hoverFileHide(param): void {
    const hover = document.getElementById('remove' + param)
    if(hover) {hover.style.display = 'none'}
  }

  hoverFileShow1(param): void {
    this.isHidden = true;
    const hover = document.getElementById('hover' + param)
    if(hover) {hover.style.display = 'block'}
  }

  hoverFileHide1(param): void {
    const hover = document.getElementById('hover' + param)
    if(hover) {hover.style.display = 'none'}
  }

  removeFile(i: any) {
    const ModalRef = this.modalService.open(CommonconfirmpopupComponent, { centered: true, size: 'md' });
    ModalRef.componentInstance.from='DeleteConfirm';
    ModalRef.result.then(res=>{
      if(res=='Yes'){
        this.uploader.queue.splice(i, 1);
        this.fileArray.splice(i, 1);
      }
    })
  }
deleteFile(i){
  const ModalRef = this.modalService.open(CommonconfirmpopupComponent, { centered: true, size: 'md' });
    ModalRef.componentInstance.from='DeleteConfirm';
    ModalRef.result.then(res=>{
      if(res=='Yes'){
        
   let toastShown=false;
  if(this.modalToOpen == 'batchCompleted'){
    this.data = {
            documentId:this.shipData.documents[i].documentId
   }
    this.customprofile.removeBatchDeliverydocument(this.shipData.code, this.data).subscribe((res) => {
            this.enableLoader = false;
            this.shipData.documents.splice(i, 1);
            if (res) {
              this.toastrService.show(res.success);
            } else {
              this.translation.translate('shipment.erroroccuredmessage').subscribe(res=>{
                if(!toastShown){
                  this.toastrService.show(res);
                  toastShown=true;
                }
                
              })
            }
          },
            err => {
              this.enableLoader = false;
              this.translation.translate('shipment.erroroccuredmessage').subscribe(res=>{
                if(!toastShown){
                  this.toastrService.show(res);
                  toastShown=true;
                }
              })
            })
  }else if(this.modalToOpen == 'screeningCompleted'){
    this.data = {
            documentId:this.shipData.screeningDocuments[i].documentId
   }
 this.customprofile.removeBatchScreeningdocument(this.shipData.code, this.data).subscribe((res) => {
            this.enableLoader = false;
            this.shipData.screeningDocuments.splice(i, 1);
            if (res) {
              this.toastrService.show(res.success);
            } else {
              this.translation.translate('shipment.erroroccuredmessage').subscribe(res=>{
                if(!toastShown){
                  this.toastrService.show(res);
                  toastShown=true;
                }
                
              })
            }
          },
            err => {
              this.enableLoader = false;
              this.translation.translate('shipment.erroroccuredmessage').subscribe(res=>{
                if(!toastShown){
                  this.toastrService.show(res);
                  toastShown=true;
                }
              })
            })
  }
      }
    })
 
   
          
          
}
// removeFile(i: any) {
//   // console.log(i, this.fileArray)
//   // this.uploader.queue.splice(i, 1);
//   // this.fileArray.splice(i, 1);
//   // if(this.updateInspectionData?.attachments){
//   //   let data = {
//   //     nominationKey :this.updateInspectionData.nominationKey,
//   //     nominationKeyItem: this.updateInspectionData.nominationItemNumber,
//   //     documentId:this.updateInspectionData.attachments[i].documentId
//   //   }
//   //   this.customprofile.removeInspdocument(this.updateInspectionData.nominationNumber, data).subscribe((res) => {
//   //     this.enableLoader = false;
//   //   //  this.ActiveModal.close();
//   //     if (res) {
//   //       this.toastrService.show(res.success);
//   //     } else {
//   //       this.toastrService.show(res.error);
//   //     }
//   //   },
//   //     err => {
//   //       this.enableLoader = false;
//   //       console.log("err", err);
//   //       this.toastrService.show("Sorry something went wrong, please try again!");
//   //     })
//   // }
  
//   }

close(status){
this.ActiveModal.close(status);
}

qualityCompleted(){
  let toastShown = false;
  this.customprofile.qualityInspectionCompleted(this.shipData.code, {}).subscribe((resp)=>{
    console.log(resp); 
    if(resp){
      this.ActiveModal.close('success');
      this.toastrService.show(resp.status);
    } else {
              this.translation.translate('shipment.erroroccuredmessage').subscribe(res=>{
                if(!toastShown){
                  this.toastrService.show(res);
                  toastShown=true;
                }
          })
    }
    
   
  },err=>{
     this.translation.translate('shipment.erroroccuredmessage').subscribe(res=>{
                if(!toastShown){
                  this.toastrService.show(res);
                  toastShown=true;
                }
          })

  });
}
}
